define('models/accounts/bank',[
    'backbone'
], function(Backbone){

    var BankAccount = Backbone.Model.extend({
        url: function () {
            var url = pf.url + '/BankAccounts?userid=';

            if(this.user_guid){
                url += this.user_guid;
            } else {
                url += pf.session.get('UserGUID');
            }
            
            return url;
        },
        initialize: function(options){
            options = options || {};
            this.user_guid = options.user_guid;
        },
        parse: function (data) {
            var response = {};

            if(data){
                response.account_id = data.account_id;
                response.account_name = data.account_name;
                response.entity_type_id = data.entity_type_id;
                response.expedite_b2c_request_allowed = data.expedite_b2c_request_allowed;
                response.expedite_c2b_request_allowed = data.expedite_c2b_request_allowed;
                response.verification_status = data.verification_status;
                response.is_verifiable = data.is_verifiable;
            }
            
            return response;
        },
    });
    return BankAccount;
    
});
